export const engineUseCrops = {
  alfalfa: 'Alfalfa and alfalfa mixtures (dry hay, greenchop, and silage)',
  barley: 'Barley',
  beans: 'Beans, dry edible',
  berries: 'Berries',
  carrots: 'Carrots',
  corn: 'Corn',
  cotton: 'Cotton',
  lettuce: 'Lettuce',
  oats: 'Oats',
  orchards: 'Orchards, vineyards, nuts',
  peanuts: 'Peanuts',
  potatoes: 'Potatoes',
  rice: 'Rice',
  sorghum: 'Sorghum',
  soybeans: 'Soybeans',
  strawberries: 'Strawberries',
  sugarbeets: 'Sugarbeets',
  sugarcane: 'Sugarcane',
  tobacco: 'Tobacco',
  tomatoes: 'Tomatoes',
  triticale: 'Triticale',
  wheat: 'Wheat',
  cropsOther: 'Other (please specify)'
};

export const engineUseMaintenance = {
  questions: {
    oilChange: 'Routine oil and filter change',
    tuneUp: 'Periodic tune-up (belts, spark plugs, etc.)',
    rebuild: 'Overhaul or rebuild',
    repair: 'Equipment repair',
    otherPart: 'Other part replacement',
    other: 'Other maintenance (please specify)'
  },
  selectOptions: {
    once: 'Once Per Year',
    twice: 'Twice Per Year',
    three: '3 Times Per Year',
    five: '5+ Times Per Year'
  }
};
